<core-layout-auth [config]="config">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit()" class="c-entry-group">
        <label for="password-1" class="c-entry-item">
            <span class="c-entry-text">{{ 'recoverPassword.newPasswordPlaceholder' | translate }}</span>
              
            <span class="c-entry-input">
                <span class="c-entry-input__addon icon-locked-thin"></span>
                <input 
                    [type]="showNewPassword() ? 'text' : 'password' " 
                    formControlName="newPassword"
                    [placeholder]="'recoverPassword.newPasswordPlaceholder' | translate"
                    [class.error]="form.get('newPassword')?.touched && form.get('newPassword')?.invalid">
                    
                    <button 
                        class="c-entry-input__addon"
                        [class]="showNewPassword() ? 'icon-password-hide-thin' :'icon-password-thin'"
                        (click)="togglePasswordVisibility('newPassword')" 
                        type="button"></button>
            </span>

            @if (form.get('newPassword')?.touched && form.get('newPassword')?.hasError('required')) {
                <span class="c-entry-error">
                    {{ 'recoverPassword.newPasswordRequired' | translate }}
                </span>
            }
            @if (form.get('newPassword')?.touched && form.get('newPassword')?.hasError('minlength')) {
                <span class="c-entry-error">
                  {{ 'recoverPassword.newPasswordMinLength' | translate }}
                </span>
            }
        </label>

        <label for="password-2" class="c-entry-item">
            <span class="c-entry-text">{{ 'recoverPassword.confirmPasswordPlaceholder' | translate }}</span>
                <span class="c-entry-input">
                    <span class="c-entry-input__addon icon-locked-thin"></span>

                    <input 
                        [type]="showConfirmPassword() ? 'text' : 'password' " 
                        formControlName="newPasswordConfirmation"
                        [placeholder]="'recoverPassword.confirmPasswordPlaceholder' | translate"
                        [class.error]="form.get('newPasswordConfirmation')?.touched && form.get('newPasswordConfirmation')?.invalid">

                        <button class="c-entry-input__addon"
                            [class]="showConfirmPassword() ? 'icon-password-hide-thin' :'icon-password-thin'"
                            (click)="togglePasswordVisibility('newPasswordConfirmation')" 
                            type="button"></button>


                </span>

                @if (form.get('newPasswordConfirmation')?.touched && form.get('newPasswordConfirmation')?.invalid) {
                    <span class="c-entry-error">
                    {{ 'recoverPassword.confirmPasswordRequired' | translate }}
                    </span>
                }
                 @if (form.hasError('mismatch') && form.get('newPasswordConfirmation')?.touched) {
                    <span class="c-entry-error">
                    {{ 'recoverPassword.passwordsMismatch' | translate }}
                    </span>
                }
                @if (form.get('newPasswordConfirmation')?.touched && form.get('newPasswordConfirmation')?.hasError('minlength')) {
                    <span class="c-entry-error">
                    {{ 'recoverPassword.confirmPasswordMinLength' | translate }}
                    </span>
                }
            </label>
        

            <button 
                type="submit" 
                class="c-login__submit c-btn" 
                [class.is-loading]="loading()"
                [disabled]="loading() || form.invalid">
                {{ 'recoverPassword.btn' | translate }}
            </button>
    </form>

  <div class="u-align-center">
    <a 
      [routerLink]="['/auth/login']" 
      class="c-link--underlined c-link--primary">
      {{ 'recoverPassword.btnBack' | translate }}
    </a>
  </div>
</core-layout-auth>